import * as quiz from './quiz'
import * as user from './user'

export const ActionCreators = Object.assign({},
	quiz,
	user,
)